import(/* webpackMode: "eager" */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/app/global-error.tsx");
